export const ROUTES = {
  home: '/',
  schools: '/schulen',
  companies: '/unternehmen',
  pricing: '/preise',
  about: '/ueber-uns',
  coach: '/coach',
  motivationLetter: '/motivationsschreiben-lehrstelle',
  resume: '/lebenslauf-lehrstelle',
  careerCheck: '/berufscheck',
  apprenticeships: '/lehrstellen',
};

export const PRIMARY_NAV = [
  ['students', ROUTES.home],
  ['schools', ROUTES.schools],
  ['companies', ROUTES.companies],
  ['pricing', ROUTES.pricing],
  ['about', ROUTES.about],
];

export const RESOURCE_NAV = [
  ['motivationLetter', ROUTES.motivationLetter],
  ['resume', ROUTES.resume],
  ['careerCheck', ROUTES.careerCheck],
  ['apprenticeships', ROUTES.apprenticeships],
];

export const EXTERNAL_LINKS = {
  app: 'https://app.yourapplicant.ch',
  meeting: 'https://calendly.com/your-applicant',
  schoolsMeeting: 'https://calendly.com/your-applicant/schulen',
  companiesMeeting: 'https://calendly.com/your-applicant/ausbildungsbetriebe',
  map: 'https://www.google.com/maps/place/Bahnhofstrasse+1,+8001+Z%C3%BCrich/@47.3673442,8.5398742,17z',
  instagram: 'https://www.instagram.com/your.applicant',
  tiktok: 'https://www.tiktok.com/@your.applicant',
  facebook: 'https://www.facebook.com/profile.php?id=61574236181860',
  youtube: 'https://www.youtube.com/@yourapplicant-ch',
  linkedin: 'https://www.linkedin.com/company/yourapplicant',
};

export const ASSETS = {
  root: '/assets/',
  logo: '/assets/logo.png',
  logoWhite: '/assets/logo-white.png',
  phone: '/assets/product/phone.png',
  notification: '/assets/product/notification.png',
  tablet: '/assets/generated/school-dashboard-clean.svg',
  schoolOverview: '/assets/generated/class-overview-clean.svg',
  schoolPersonality: '/assets/product/personality.png',
  schoolInvolved: '/assets/generated/involved-clean.svg',
  comicBoy: '/assets/optimized/people/4aed114fe6b983d3.avif',
  comicBoySchool: '/assets/optimized/people/f4fff1fd3b9404db.avif',
  comicGirl: '/assets/optimized/people/2ecafd8303a9d2c6.avif',
  exampleCv: '/assets/original/example-cv.png',
  templateCv: '/assets/original/template-cv.png',
  templatePlatform: '/assets/original/template-platform.png',
  recruitingOverview: '/assets/generated/school-dashboard-clean.svg',
};

export const PEOPLE = [
  { name: 'Aleyna', company: 'YourApplicant', src: '/assets/optimized/people/125395263c5d3af1.avif', original: '/assets/people/125395263c5d3af1.png' },
  { name: 'Ben', company: 'Coca-Cola', src: '/assets/optimized/people/4aed114fe6b983d3.avif', original: '/assets/people/4aed114fe6b983d3.png' },
  { name: 'Chiara', company: 'Midor', src: '/assets/optimized/people/2ecafd8303a9d2c6.avif', original: '/assets/people/2ecafd8303a9d2c6.png' },
  { name: 'Manuel', company: 'Atlantis', src: '/assets/optimized/people/f4fff1fd3b9404db.avif', original: '/assets/people/f4fff1fd3b9404db.png' },
  { name: 'Lenny', company: 'Logistics', src: '/assets/optimized/people/eb6c05c285fa2f83.avif', original: '/assets/people/eb6c05c285fa2f83.png' },
  { name: 'Elio', company: 'Technology', src: '/assets/optimized/people/7ab58da03569d739.avif', original: '/assets/people/7ab58da03569d739.png' },
];

export const TEAM = [
  { name: 'Devin Baucamp', roleKey: 'devin', src: '/assets/optimized/team/24bc3e059a6c06e1.avif', original: '/assets/team/24bc3e059a6c06e1.png' },
  { name: 'Lubo Dilov', roleKey: 'lubo', src: '/assets/optimized/team/9318477e71c7065c.avif', original: '/assets/team/9318477e71c7065c.jpg' },
  { name: 'Aleksander Dimitrov', roleKey: 'aleksander', src: '/assets/optimized/team/e4d0c572aa3ad34a.avif', original: '/assets/team/e4d0c572aa3ad34a.jpg' },
  { name: 'Aleyna Arslan', roleKey: 'aleyna', src: '/assets/optimized/team/159f89aa667fcacf.avif', original: '/assets/team/159f89aa667fcacf.png' },
  { name: 'Samira Bannwart', roleKey: 'samira', src: '/assets/optimized/team/e7ba8f0d8409174a.avif', original: '/assets/team/e7ba8f0d8409174a.png' },
  { name: 'Leon Sarkis', roleKey: 'leon', src: '/assets/optimized/team/d59cbe727dc7c7fa.avif', original: '/assets/team/d59cbe727dc7c7fa.png' },
];
